import React from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { PHANBIENDOCLAP_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';

const schema = yup.object().shape({
});

const PhanBienDocLapAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(PHANBIENDOCLAP_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            IsBanGiaiTrinh: values.isBanGiaiTrinh === 'true',
            FileDinhKem: values.isBanGiaiTrinh === 'true' ? (values.fileDinhKem || '') : '',
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['duyetPhanBienDocLapData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Phản biện độc lập</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        isBanGiaiTrinh: 'true',
                        fileDinhKem: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold d-block">Biên bản giải trình</Form.Label>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isBanGiaiTrinh"
                                            id="isBanGiaiTrinh-true"
                                            value="true"
                                            checked={values.isBanGiaiTrinh === 'true'}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isBanGiaiTrinh"
                                            id="isBanGiaiTrinh-false"
                                            value="false"
                                            checked={values.isBanGiaiTrinh === 'false'}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {values.isBanGiaiTrinh === 'true' && (
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <DocumentInput
                                                labelTitle="File đính kèm"
                                                value={values.fileDinhKem}
                                                onChangeProp={(url) => setFieldValue('fileDinhKem', url)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Đóng
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Lưu lại'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default PhanBienDocLapAdd;
